class Decorators {
  constructor(decorators, context) {
    this.DEFAULT_PRIORITY = 0;
    this.decorators = [];
    this.textualDecorators = [];
    this.decorators = decorators.filter((decorator) => !decorator.isText).sort(
      (a, b) => {
        var _a, _b;
        return ((_a = b.priority) != null ? _a : this.DEFAULT_PRIORITY) - ((_b = a.priority) != null ? _b : this.DEFAULT_PRIORITY);
      }
    );
    this.textualDecorators = decorators.filter((decorator) => decorator.isText);
    this.context = context;
  }
  static of(decorators, context) {
    return new Decorators(decorators, context);
  }
  getDecorators() {
    return this.decorators;
  }
  merge(decorators) {
    return Decorators.of([...this.decorators, ...decorators.getDecorators()], this.context);
  }
  apply(element, node, isRoot) {
    return this.decorators.reduce((decorated, decorator) => {
      if (decorator.rule(node)) {
        return decorator.decorate({ node, context: this.context, element: decorated, isRoot });
      }
      return decorated;
    }, element);
  }
  applyTextual(node) {
    const decorator = this.textualDecorators.find((decorator2) => decorator2.rule(node));
    return decorator == null ? void 0 : decorator.decorate({ node, context: this.context, isRoot: false });
  }
}

export { Decorators };
//# sourceMappingURL=nodeViewDecorators.js.map
